import { render, staticRenderFns } from "./bidResultNotification.vue?vue&type=template&id=008becd3&scoped=true"
import script from "./bidResultNotification.vue?vue&type=script&lang=js"
export * from "./bidResultNotification.vue?vue&type=script&lang=js"
import style0 from "./bidResultNotification.vue?vue&type=style&index=0&id=008becd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008becd3",
  null
  
)

export default component.exports